const StarIcon = ({ className = '' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      className={className}
    >
      <path
        d="M7.5 0.616699C7.5 0.616699 8.60766 4.05658 9.86942 5.31834C11.1312 6.5801 14.5711 7.68777 14.5711 7.68777C14.5711 7.68777 11.1312 8.79543 9.86942 10.0572C8.60766 11.319 7.5 14.7588 7.5 14.7588C7.5 14.7588 6.39234 11.319 5.13058 10.0572C3.86882 8.79543 0.428932 7.68777 0.428932 7.68777C0.428932 7.68777 3.86882 6.5801 5.13058 5.31834C6.39234 4.05658 7.5 0.616699 7.5 0.616699Z"
        fill="#4B4C36"
      />
    </svg>
  )
}

export default StarIcon
